import Grid from '@mui/material/Grid';
import React from 'react';

import s from './CaseStudyList.module.scss';
import CaseStudyPreview from './CaseStudyPreview';

function CaseStudyList({ title, cases, titleStyle, dim, caseTitleStyle, ...other }: any) {
  return (
    <div className={s.root} {...other}>
      {title && (
        <h2 className={s.title} style={titleStyle}>
          {title}
        </h2>
      )}
      <Grid container spacing={4}>
        {cases.map((c: any) => (
          <Grid key={c.slug} item sm={12} md={6} lg={4}>
            <CaseStudyPreview dim={dim} titleStyle={caseTitleStyle} {...c} />
          </Grid>
        ))}
      </Grid>
    </div>
  );
}

export default CaseStudyList;
